import StandardQueriesPanel from "../../../../components/panels/StandardQueries";
import { Inset, Popover } from "@radix-ui/themes";
import { IoIosHelpCircleOutline } from "react-icons/io";
import SIZE from "./size";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../store";
import { updateLiveStreamSettings } from "../../../../store/reducers/livestreamSettings";


const RaiseHandControl = () => {
  const settings: any = useSelector((state: RootState) => state.live.settings);
  const dispatch = useDispatch();
  return (
    <div className="relative group">
      <Popover.Root
        open={settings.raiseHand}
        onOpenChange={(open) =>
          dispatch(updateLiveStreamSettings({ raiseHand: open }))
        }
      >
        <Popover.Trigger>
          <div
            className="flex h-12 w-12  largescreen:h-14 largescreen:w-14 items-center justify-center rounded-full cursor-pointer mobile:hidden"
            style={{
              background: "rgb(95, 72, 138)",
              boxShadow:
                "rgb(152, 122, 209) -8px -8px 16px inset, rgba(2, 2, 2, 0.61) 8px 8px 8px inset",
            }}
            onClick={() =>
              dispatch(
                updateLiveStreamSettings({ raiseHand: !settings.raiseHand })
              )
            }
          >
            <IoIosHelpCircleOutline color="white" size={SIZE} />
          </div>
        </Popover.Trigger>

        <Popover.Content style={{ width: 400 }}>
          <Inset>
            <StandardQueriesPanel
            />
          </Inset>
        </Popover.Content>
      </Popover.Root>

      <div className="absolute bottom-full mb-2 left-1/2 transform -translate-x-1/2 max-w-md bg-black text-white text-sm rounded py-1 px-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
        Queries
      </div>
    </div>
  );
};

export default RaiseHandControl;
